import React from 'react';
import { Redirect } from 'react-router'
import '../css/App.css';
import AppBody from "./AppBody";
import axios from "axios";
import urls from "../configs/urls";
import ls from "local-storage";
import {
    BrowserView,
    MobileView,
} from "react-device-detect";
class DeliveryRequest extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            redirect : false,
            reload : false,
            text : "",
            phone:''
        };

    }
    componentDidMount() {
        this.getDeliveryInfo();
    }

    render() {
        if(this.state.redirect)
            return (<Redirect to={this.state.url}/>);
        return (
            <AppBody loading={this.state.loading} name={"درخواست پیک"} type={" bg-white"}>
                <div className={"infoMessage"}>
                    {this.state.text}
                    <br/>
                    <br/>
                    <BrowserView>{this.state.phone}</BrowserView>
                    <MobileView><a href={"tel:"+this.state.phone} className={"btn btn-success"} id={"DeliveryPhone"}><i className="serviceItemText glyphicon glyphicon-earphone"/></a></MobileView>
                </div>

            </AppBody>
        );
    }

    getDeliveryInfo=()=>{
        this.setState({loading:true});
        axios.get(urls.baseUrl+urls.getDelivery+"?"
            +"token="+ls.get("token")
            +"&city_id="+ls.get("city_id")
        )
            .then(res => {
                this.setState({loading:false,phone:res.data.phone,text:res.data.text});

            })
            .catch(error => {
                console.log(error);
                this.setState({text : "کاربر گرامی آسونه، این بخش جهت سهولت در جابجایی مرسوله ساخته شده است.", phone:'09196626444'});
            });


    }

}



export default DeliveryRequest;
